import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { EditorTabAlert } from './EditorTabAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorWrapper = styled.div.withConfig({
  displayName: "TabbedEditorErrorState__ErrorWrapper",
  componentId: "sc-1xsnikv-0"
})(["display:flex;flex-direction:column;align-items:stretch;justify-content:center;min-height:156px;border-top:1px solid ", ";background:", ";"], GREAT_WHITE, OLAF);
const AlertWrapper = styled.div.withConfig({
  displayName: "TabbedEditorErrorState__AlertWrapper",
  componentId: "sc-1xsnikv-1"
})(["padding:20px;"]);
const TabSpacer = styled.div.withConfig({
  displayName: "TabbedEditorErrorState__TabSpacer",
  componentId: "sc-1xsnikv-2"
})(["height:49px;width:100%;border-bottom:1px solid ", ";flex-shrink:0;"], GREAT_WHITE);
export function TabbedEditorErrorState({
  reset = () => {}
}) {
  return /*#__PURE__*/_jsxs(ErrorWrapper, {
    children: [/*#__PURE__*/_jsx(TabSpacer, {}), /*#__PURE__*/_jsx(AlertWrapper, {
      children: /*#__PURE__*/_jsx(EditorTabAlert, {
        reset: reset
      })
    })]
  });
}
TabbedEditorErrorState.displayName = 'TabbedEditorErrorState';